var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000856",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: 57.6,
    y1: 254.7,
    x2: 57.6,
    y2: 257,
    gradientTransform: "translate(118.9 295.8) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7187e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b198f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-2",
    x1: 13,
    y1: 252.9,
    x2: 13,
    y2: 258.8,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-3",
    x1: 43.6,
    y1: 252.9,
    x2: 43.6,
    y2: 258.8,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-4",
    x1: 74.1,
    y1: 252.9,
    x2: 74.1,
    y2: 258.8,
    xlinkHref: "#Degradado_sin_nombre_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4-5",
    x1: 104.7,
    y1: 252.9,
    x2: 104.7,
    y2: 258.8,
    xlinkHref: "#Degradado_sin_nombre_4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,52.2c9.5,6.1,16.5,1,30.3,12.6,11,9.3,21.1,3.8,25.7-.6,2.2-2.1,8-11.9,1.3-15.8C83.2,34.8,79.3-1.2,55.6,14.9s-28.6,23.5-7.1,37.3Z",
    style: {
      fill: "#b198f8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.7,
    y: 27.4,
    width: 106.7,
    height: 25.2,
    rx: 3.6,
    ry: 3.6,
    style: {
      fill: "#fff",
      filter: "url(#drop-shadow-1)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 38.9,
    width: 90.7,
    height: 2.3,
    style: {
      fill: "url(#Degradado_sin_nombre_4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.8,
    cy: 40,
    r: 2.9,
    style: {
      fill: "url(#Degradado_sin_nombre_4-2)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.3,
    cy: 40,
    r: 2.9,
    style: {
      fill: "url(#Degradado_sin_nombre_4-3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.7,
    cy: 40,
    r: 2.9,
    style: {
      fill: "url(#Degradado_sin_nombre_4-4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.2,
    cy: 40,
    r: 2.9,
    style: {
      fill: "url(#Degradado_sin_nombre_4-5)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinear);
export default __webpack_public_path__ + "static/media/linear.258bc6a0db82bb64f17ff9a230647940.svg";
export { ForwardRef as ReactComponent };